<template>
  <div>
    <el-dialog
            title="Confirm Delete"
            :visible.sync="should_show_confirm_delete">

        <p>Are you sure you want to delete?</p>
        <el-button v-on:click="deleteStepTwo()" type="danger">Yes, really delete.</el-button>
        <el-button v-on:click="cancelDelete()" type="success">Oops. Actually, do not delete.</el-button>

    </el-dialog>
    <el-dialog
        title="Report Info"
        :visible.sync="showModal"
        width="75%"
    >
      <FormManager
          @save="save"
          @cancel="showModal = false"
          :initialFormValues="editReport"
          :events="events"
          prettyEndPoint="/api/reports/pretty" />
    </el-dialog>
    <div class="row">
      <div class="col-md-12 ">
        <div class="panel panel-default">
          <div class="panel-heading">
              <span v-if="extentName">
                  {{extentName}}
              </span>
              <span v-else>
                  Your
              </span>
              Reports
          </div>
          <div class="panel-body" v-if="reports">
            <el-button v-if="extentId" @click="create" style="padding: 25px;margin-left:20px;">Create Report</el-button>
            <el-row v-for="row in reports.rows">

              <el-col :span="6"  v-for="report in row">
                <el-card class="box-card" :style="'margin:20px;background-color:'+report.color">
                  <div slot="header" class="clearfix">
                                <span>
                                  <a :href="report.url">
                                      {{report.title}} ({{report.extent_name}})
                                  </a>
                                  <el-button @click="edit(report)" style="padding-top:2px;float:right;" type="text" icon="el-icon-edit"></el-button>
                                </span>
                  </div>
                  <div style="margin-bottom:20px;">{{ report.description }}</div>
                  <p style="font-size:smaller">{{report.types_text}}</p>
                  <p v-if="report.owner" style="font-size:smaller;color:gray;">Owner: {{report.owner.name}}</p>
                  <p style="font-size:smaller;color:gray;">Last time report definition changed: {{report.last_updated}}</p>
                  <el-button type="text" style="padding-top:2px;float:right;" @click="deleteStepOne(report)" icon="el-icon-delete"></el-button>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.fetchReports();
  },
  props: ['extentId','extentName'],
  data() {
    return {
      reports: null,
      editReport: null,
      showModal: false,
      events: {
        save: {
          label: "Save",
          event: "save"
        },
        cancel: {
          label: "Cancel",
          event: "cancel"
        }
      },
      should_show_confirm_delete: false,
      report_id_for_deletion: null,
    }
  },
  methods: {
    async fetchReports() {
      try {
        const { data } = await axios.get(this.extentId ? `/api/extents/${this.extentId}/reports` : "/api/user/reports");
        this.reports = data;
      } catch (error) {
        console.error(error);
      }
    },
    edit(report) {
      this.editReport = report;
      this.showModal = true;
    },
    cancelDelete() {
      this.should_show_confirm_delete = false
    },
    deleteStepOne(report) {
        this.should_show_confirm_delete = true
        this.report_id_for_deletion = report.id
    },
    deleteStepTwo() {
        axios.delete('/api/reports/' + this.report_id_for_deletion)
            .then(response => {
                console.log('deleted')
                // Should really remove from the front end too
                this.should_show_confirm_delete = false
                location.reload()
            })
            .catch(error => {
                this.should_show_confirm_delete = false
                console.log('could not delete')
            })
    },
    create() {
      this.editReport = null;
      this.showModal = true;
    },
    async save(report) {
      try {
        if (report.id) {
          await axios.put(`/api/reports/${report.id}`, report);
        } else {
          await axios.post(`/api/extents/${this.extentId}/reports`, report);
        }
        await this.fetchReports();
        this.showModal = false;
      } catch (error) {
        console.error(error);
      }
    }
  }
}
</script>